import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/AdPage.css';
import NativeBanner from '../components/NativeBanner';

const AdPage2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showButton, setShowButton] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [countdown, setCountdown] = useState(8);
  const [countdownComplete, setCountdownComplete] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const postId = searchParams.get('go');

  useEffect(() => {
    if (!postId) {
      navigate('/');
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setCountdownComplete(true);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [postId, navigate]);

  useEffect(() => {
    if (!countdownComplete) return;

    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
      setScrollProgress(Math.min(scrollPercentage, 100));
      if (scrollPercentage > 70) setShowButton(true);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [countdownComplete]);

  const handleGoToPost = () => {
    if (showButton) {
      window.open('https://www.profitableratecpmnetwork.com/p30hpe5v?key=308e8f6fbe3fe7839661a714c9301acf', '_blank');
      navigate(`/post/${postId}`);
    }
  };

  return (
    <div className="ad-page-container ad-page-2">
      <div className="scroll-progress-bar">
        <div className="scroll-progress-fill" style={{ width: `${scrollProgress}%` }} />
      </div>

      <div className="ad-page-content">
        <div className="ad-page-card">
          <h1>ခဏလေးစောင့်ပါ!</h1>
          <p className="ad-page-subtitle">
            {!countdownComplete
              ? `${countdown} စက္ကန့် စောင့်ပေးပါ...`
              : showButton
                ? "ကျေးဇူးတင်ပါတယ်! ဆက်လက်ဖတ်ရှုနိုင်ပါပြီ"
                : "ဆက်သွားရန် အောက်သို့ Scroll ဆွဲပါ"}
          </p>

          {!countdownComplete && (
            <div className="countdown-section">
              <div className="countdown-circle">
                <span className="countdown-number">{countdown}</span>
              </div>
              <p className="countdown-text">အောက်သို့မသွားခင် {countdown} စက္ကန့် စောင့်ပါ...</p>
            </div>
          )}

          {countdownComplete && !showButton && (
            <div className="scroll-instruction">
              <div className="scroll-arrow bounce">↓</div>
              <p>အောက်သို့သွားပါ</p>
            </div>
          )}

          <NativeBanner />

          <div className="ad-section">
            <h3>ကြော်ငြာ</h3>
            <NativeBanner />
          </div>

          <div className="dummy-content">
            <div className="content-block">
              <h2>အရေးကြီး အသိပေးချက်</h2>
              <p>စိတ်ရှည်ပေးတဲ့အတွက် ကျေးဇူးတင်ပါတယ်။ အားလုံးအတွက် အခမဲ့ ဖတ်ရှုနိုင်အောင် ကြော်ငြာလေးတွေ ထည့်ထားခြင်းဖြစ်ပါတယ်။</p>
              <div className="ad-placeholder"><NativeBanner /></div>
            </div>
            <div className="content-block">
              <h2>ကူညီပံ့ပိုးပေးပါ</h2>
              <p>ဒီကြော်ငြာတွေကို ကြည့်ရှုပေးခြင်းဖြင့် ကျွန်တော်တို့ကို ကူညီရာရောက်ပါတယ်။</p>
              <div className="ad-placeholder"><NativeBanner /></div>
            </div>
            <div className="content-block">
              <h2>စာဖတ်ရန် အဆင်သင့်ဖြစ်ပါပြီ</h2>
              <p>လိုချင်တဲ့ စာမျက်နှာရောက်ဖို့ နည်းနည်းလေးပဲ လိုပါတော့တယ်။</p>
              <div className="ad-placeholder"><NativeBanner /></div>
            </div>
            <div className="content-block">
              <h2>ကျေးဇူးတင်ပါတယ်!</h2>
              <p>အားပေးမှုကို ကျေးဇူးတင်ပါတယ်။ ဆက်သွားရန် အောက်သို့ ဆက်ဆွဲပါ။</p>
              <div className="ad-placeholder"><NativeBanner /></div>
            </div>
          </div>

          {showButton && (
            <div className="final-button-section">
              <button onClick={handleGoToPost} className="continue-button final-button pulse">
                ✓ စာဖတ်ရန် နှိပ်ပါ →
              </button>
            </div>
          )}

          {!showButton && (
            <div className="bottom-instruction">
              <p>↓ အောက်သို့ ဆက်သွားပါ ↓</p>
            </div>
          )}
        </div>
      </div>

      <NativeBanner />
    </div>
  );
};

export default AdPage2;
